import { graphql } from '@e-socna/data-layer';

import { Loading } from '../../components/Loading';
import { useReferencesContext } from '../../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import { useGraphQLQuery } from '../../hooks/useGraphQLQuery.hook';

import { List } from './List';

export const UsersPage_InternalUsersTabPanel_AllInternalUsers_QueryDocument =
  graphql(`
    query UsersPage_InternalUsersTabPanel_AllInternalUsers_Query {
      findAllInternalUsers {
        ...UsersPage_List_User_Fragment
        statusId
      }
    }
  `);

export const InternalUsersTabPanel = () => {
  const { genericStatusesCodeMap } = useReferencesContext();

  const { data, isSuccess } = useGraphQLQuery(
    UsersPage_InternalUsersTabPanel_AllInternalUsers_QueryDocument,
  );

  if (isSuccess) {
    const allInternalUsers = data.findAllInternalUsers;

    const enabledInternalUsers = allInternalUsers.filter(
      (user) => user.statusId === genericStatusesCodeMap.Enabled._id,
    );

    return <List users={enabledInternalUsers} />;
  }

  return <Loading />;
};
